const digest = '2b8ec1eca168561c289ddb6479a0d40d1b1019f0d620aded0798dfcef01b8fa9';
const css = `._suggestionsWrapper_1hoy1_1{overflow:auto;overscroll-behavior:contain;z-index:80}@media (max-width:799px){._suggestionsWrapper_1hoy1_1{border:none;box-shadow:none;left:0;position:fixed;right:0;z-index:100}}@media (min-width:800px){._suggestionsWrapper_1hoy1_1{max-width:calc(100% + 1.25rem);min-width:31.25rem}}._suggestion_1hoy1_1{cursor:pointer;max-height:44px;min-height:44px}._suggestion_1hoy1_1 p{max-height:44px;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word;white-space:normal}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'suggestionsWrapper': '_suggestionsWrapper_1hoy1_1', 'suggestion': '_suggestion_1hoy1_1' };
export const suggestionsWrapper = '_suggestionsWrapper_1hoy1_1';
export const suggestion = '_suggestion_1hoy1_1';
export { css, digest };